class PagedCollection {
  constructor (items, pagingData) {
    this.items = items
    this.pagingData = {
      link: pagingData.link,
      currentPage: parseInt(pagingData['x-pagination-current-page']),
      totalPageCount: parseInt(pagingData['x-pagination-page-count']),
      perPage: parseInt(pagingData['x-pagination-per-page']),
      totalItemCount: parseInt(pagingData['x-pagination-total-count'])
    }
  }

  getItems () {
    return this.items
  }

  getCurrentPage () {
    return this.pagingData.currentPage
  }

  getTotalPageCount () {
    return this.pagingData.totalPageCount
  }

  getPerPage () {
    return this.pagingData.perPage
  }

  getTotalItemCount () {
    return this.pagingData.totalItemCount
  }

  /**
   * Return the numeric position of the first item in the set relative to the
   * whole set. For example if we have 25 items per page and are on page 3
   * then the first item on this page is number 51 in the whole set
   */
  getItemCountFrom () {
    if (this.getCurrentPage() === 1) {
      return 1
    } else {
      return ((this.getCurrentPage() - 1) * this.getPerPage()) + 1
    }
  }

  /**
   * Return the numeric position of the last item in the set relative to the
   * whole set. For example if we have 25 items per page and are on page 3
   * then the last item on this page is number 75 in the whole set
   */
  getItemCountTo () {
    if (this.currentPage === 1) {
      return Math.min(this.getPerPage(), this.getTotalItemCount())
    } else {
      return Math.min((((this.getCurrentPage() - 1) * this.getPerPage()) + this.getPerPage()), this.getTotalItemCount())
    }
  }
}

export default PagedCollection
